import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, url, type = 'website' }) => {
    const siteUrl = 'https://www.cider-clothings.com';
    const canonicalUrl = url ? `${siteUrl}${url}` : siteUrl;

    return (
        <Helmet>
            {title && <title>{title} | Cider Clothings</title>}
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={canonicalUrl} />
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={canonicalUrl} />
            {title && <meta property="twitter:title" content={title} />}
            {description && <meta property="twitter:description" content={description} />}
        </Helmet>
    );
};

export default SEO;
